import { render, staticRenderFns } from "./ActivityIntro.vue?vue&type=template&id=2819bbd4&scoped=true"
import script from "./ActivityIntro.vue?vue&type=script&lang=js"
export * from "./ActivityIntro.vue?vue&type=script&lang=js"
import style0 from "./ActivityIntro.vue?vue&type=style&index=0&id=2819bbd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819bbd4",
  null
  
)

export default component.exports